import React, { useEffect, useRef, useState } from 'react'
import { Formik } from 'formik'
import { Link, useNavigate } from 'react-router-dom'
import { baseURL } from 'src/config/config'
import { post, get } from 'src/utils/apiManager'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CCard, CCardBody, CCardGroup, CCol, CContainer, CFormCheck, CFormLabel, CRow } from '@coreui/react'
import { DefaultMobileInput, DefaultInput } from 'src/components/common/input'
import { validateSubAdmin } from 'src/utils/validator'
import index from '.'
import { object } from 'prop-types'

function add() {
  const navigate = useNavigate()
  const formRef = useRef(null)
  const fileRef = useRef(null)
  const [invalidImage, setInvalidImage] = useState('')
  const [moduleName, setModuleName] = useState([])

  const getModules = () => {
    get(`/admin/subAdmin/sidebar-modules`).then((data) => handleResponseModule(data))
  }
  const handleResponseModule = (data) => {
    if (data?.status == true) {
      let tempData = []
      tempData = data?.data?.map((item, index) => {
        return {
          ...item,
          chacked: false,
          isAdd: false,
          isEdit: false,
          isDelete: false,
          isView: false,
        }
      })
      setModuleName(tempData)
    }
  }
  useEffect(() => {
    getModules()
  }, [])

  const submit = async (values) => {
    // console.log(values)
    let moduleArr = []
    let moduleData = []

    moduleArr = moduleName?.filter((item, index) => item?.chacked)

    moduleArr?.map((value, key) => {
      // console.log(value?._id,value?.isAdd,value?.isEdit,value?.isView,value?.isDelete)
      moduleData.push({
        _id: value?._id,
        name: value?.name,
        isAdd: value?.isAdd,
        isEdit: value?.isEdit,
        isView: value?.isView,
        isDelete: value?.isDelete,
      })
    })
    let data = {
      username: values?.username,
      email: values?.email,
      mobile: values?.mobile,
      moduleId: moduleData,
    }
    // console.log(data)
    if (moduleData.length > 0) {
      post(`/admin/subAdmin/add-subadmin`, data).then((data) => {
        handleResponse(data)
      })
    } else {
      toast.warn('Select a permission module !')
    }
  }
  const handleResponse = (data) => {
    // console.log(data)
    if (data?.status == true) {
      toast.success(data?.message)
      setTimeout(() => {
        navigate('/admin/sub-admin')
      }, 800)
    } else {
      toast.error(data?.message)
    }
    formRef.current.resetForm()
    // fileRef.current.value = null
  }
  const onClickReset = () => {
    // Reset Button Function
    formRef.current.setFieldValue('username', '')
    formRef.current.setFieldValue('email', '')
    fileRef.current.value = null
    formRef.current.setFieldValue('mobile', '')
    formRef.current.setFieldValue('password', '')
  }

  const handleCheckParent = ({ _id }) => {
    let tempData = []
    tempData = moduleName?.map((item, index) => {
      if (_id == item?._id) {
        return { ...item, chacked: !item?.chacked }
      } else {
        return item
      }
    })
    setModuleName(tempData)
  }

  const handleCheckChild = (value, chiledKey) => {
    let tempData = []
    tempData = moduleName?.map((item, index) => {
      if (item?._id == value?._id) {
        return { ...item, [chiledKey]: !value?.[chiledKey] }
      } else {
        return item
      }
    })
    setModuleName(tempData)
  }
  const handleAllSelect=(e)=>{
    console.log(e.target.checked);
     let tempData = []
    tempData = moduleName?.map((item, index) => {

        return { ...item, chacked: e.target.checked }
      
    })
    setModuleName(tempData)
  }

  return (
    <>
      <CContainer>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard className="p-4">
                <CCol xs={12}>
                  <CCardGroup>
                    <CCardBody>
                      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
                      <CRow>
                        <CCol md="11">
                          <h1>Add sub-admin</h1>
                        </CCol>
                        <CCol md="1">
                          <Link
                            className={'btn btn-success mt-2'}
                            style={{ background: '#d3dc40', border: '#d3dc40' }}
                            to={{ pathname: `/admin/sub-admin` }}
                          >
                            Back
                          </Link>
                        </CCol>
                      </CRow>
                      <Formik
                        initialValues={{
                          username: '',
                          email: '',
                          image: '',
                          mobile: '',
                          moduleId: '',
                          isAdd: '',
                          isEdit: '',
                          isDelete: '',
                          isView: '',
                        }}
                        validationSchema={validateSubAdmin}
                        onSubmit={(values, { setSubmitting }) => {
                          submit(values)
                          setSubmitting(false)
                        }}
                        innerRef={formRef}
                      >
                        {(props) => (
                          <form onSubmit={props?.handleSubmit}>
                            <CRow xs={12}>
                              <CCol md={6}>
                                <CFormLabel>Name</CFormLabel>
                                <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                                <DefaultInput
                                  type={'text'}
                                  placeholder={'Name'}
                                  id={'username'}
                                  maxLength="70"
                                  value={props?.values?.username}
                                  onChange={props?.handleChange('username')}
                                  onBlur={() => props?.setFieldTouched('username', true)}
                                  error={props?.touched?.username && props?.errors?.username}
                                />
                              </CCol>
                              <CCol md={6}>
                                <CFormLabel>Email</CFormLabel>
                                <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                                <DefaultInput
                                  type={'email'}
                                  placeholder={'Email'}
                                  id={'email'}
                                  value={props?.values?.email}
                                  onChange={props?.handleChange('email')}
                                  onBlur={() => props?.setFieldTouched('email', true)}
                                  error={props?.touched?.email && props?.errors?.email}
                                />
                              </CCol>
                            </CRow>
                            <CRow xs={12}>
                              <CCol md={6}>
                                <DefaultMobileInput
                                  type={'text'}
                                  placeholder={'Mobile'}
                                  name={'Mobile'}
                                  id={'mobile'}
                                  minLength={7}
                                  maxLength={15}
                                  value={props?.values?.mobile}
                                  onChange={(val) => props?.setFieldValue('mobile', val || '')}
                                  onBlur={() => props?.setFieldTouched('mobile', true)}
                                  error={props?.touched?.mobile && props?.errors?.mobile}
                                />
                              </CCol>
                              {/* <CCol md={6}>
                            <DefaultInput
                            type={'file'}
                            placeholder={'Image'}
                            name={'Image'}
                            // accept="image/*"
                            accept="image/png, image/gif, image/jpeg, image/jpg"
                            refr={fileRef}
                            onChange={(e) => {
                              const imageFile = e.target.files[0];                         
                              if (!imageFile.name.match(/\.(jpg|jpeg|png|gif)$/)) {
                                setInvalidImage("Please select valid image")
                              }
                              else{
                                setInvalidImage('')
                              }
                              props?.setFieldValue('image', e.target.files[0])
                            }}
                            onBlur={() => props?.setFieldTouched('image', true)}
                            error={(props?.touched?.image && props?.errors?.image) || invalidImage}
                          />
                            </CCol> */}
                            </CRow>
                            <CRow className="mt-4">
                              <CCol>
                                <div className="card">
                                  <div className="card-body">
                                    <strong>Modules Permission</strong>
                                    <br/>
                                    <input type='checkbox' onChange={(e)=>handleAllSelect(e)} />
                                    <label>&nbsp; All Select</label>
                                    <hr />
                                    <CRow className="mt-2">
                                      <CCol>
                                        {moduleName?.map((value, key) => {
                                          return (
                                            <>
                                              <CRow key={key}>
                                                <CCol>
                                                  {/* <span>{value?.name}<br/></span> */}
                                                  <CFormCheck
                                                    id={value?._id}
                                                    label={value?.name}
                                                    style={{cursor: "pointer"}}
                                                    checked={value?.chacked}
                                                    onChange={(val) => handleCheckParent(value)}
                                                  />
                                                </CCol>
                                                <CCol>
                                                  <strong>Add</strong>
                                                  <CFormCheck
                                                    id="flexCheckChecked"
                                                    label="Checkbox"
                                                    className="mt-2"
                                                    style={{cursor: "pointer"}}
                                                    disabled={value?.chacked ? false : true}
                                                    checked={value?.isAdd}
                                                    onChange={(val) => {
                                                      handleCheckChild(value, 'isAdd')
                                                    }}
                                                  />
                                                </CCol>
                                                <CCol>
                                                  <strong>Edit</strong>
                                                  <CFormCheck
                                                    id="flexCheckChecked"
                                                    label="Checkbox"
                                                    className="mt-2"
                                                    style={{cursor: "pointer"}}
                                                    disabled={value?.chacked ? false : true}
                                                    checked={value?.isEdit}
                                                    onChange={(val) => {
                                                      handleCheckChild(value, 'isEdit')
                                                    }}
                                                  />
                                                </CCol>
                                                <CCol>
                                                  <strong>Delete</strong>
                                                  <CFormCheck
                                                    id="flexCheckChecked"
                                                    label="Checkbox"
                                                    className="mt-2"
                                                    style={{cursor: "pointer"}}
                                                    disabled={value?.chacked ? false : true}
                                                    checked={value?.isDelete}
                                                    onChange={(val) => {
                                                      handleCheckChild(value, 'isDelete')
                                                    }}
                                                  />
                                                </CCol>
                                                <CCol>
                                                  <strong>View</strong>
                                                  <CFormCheck
                                                    id="flexCheckChecked"
                                                    label="Checkbox"
                                                    className="mt-2"
                                                    style={{cursor: "pointer"}}
                                                    disabled={value?.chacked ? false : true}
                                                    checked={value?.isView}
                                                    onChange={(val) => {
                                                      handleCheckChild(value, 'isView')
                                                    }}
                                                  />
                                                  {/* <CFormCheck id="flexCheckChecked" label="Checked checkbox" defaultChecked /> */}
                                                </CCol>
                                              </CRow>
                                              <hr />
                                            </>
                                          )
                                        })}
                                      </CCol>
                                    </CRow>
                                  </div>
                                </div>
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol md="2">
                                <button
                                  type="submit"
                                  className={'btn btn-success mt-2'}
                                  disabled={props?.isSubmitting}
                                >
                                  Submit
                                </button>
                              </CCol>
                              <CCol md="2">
                                <button
                                  type="button"
                                  className={'btn btn-warning mt-2'}
                                  onClick={onClickReset}
                                >
                                  Reset
                                </button>
                              </CCol>
                              <CCol md="3"></CCol>
                            </CRow>
                          </form>
                        )}
                      </Formik>
                    </CCardBody>
                  </CCardGroup>
                </CCol>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </>
  )
}

export default add
